// extracted by mini-css-extract-plugin
export default {"footer":"AppFooter_footer__zQk5w","footerContent":"AppFooter_footerContent__uTMGa","logo":"AppFooter_logo__sDgKN","row":"AppFooter_row__NyR-Y"};